<template>
    <div v-if="!cookieNoticeHidden" class="cookie-notice">
        <p>Deze site maakt gebruik van cookies om uw surfervaring te optimaliseren. Door deze website te gebruiken stemt u in met onze privacydisclaimer en cookiebeleid.</p>
        <button href="#" class="btn btn-primary" @click.prevent="hideCookieNotice">Ik snap het</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            cookieNoticeHidden: localStorage.getItem("hide_cookie_notice")
        };
    },
    methods: {
        hideCookieNotice() {
            this.cookieNoticeHidden = true;
            localStorage.setItem("hide_cookie_notice", true);
        }
    }
};
</script>

<style lang="scss" scoped>
.cookie-notice {
    background-color: $dark;
    position: fixed;
    padding: 25px;
    left: 15px;
    bottom: 15px;
    right: 15px;
    max-width: 400px;
    color: lighten($body, 40%);
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
}
</style>
